import React, { FC } from 'react'
import classNames from 'classnames'

import { getStyledElementProps } from '@/utils'
import { IconMoonProps } from '@/types'
import styles from './icon-moon.module.scss'
import { complexIconMoonName } from './constants'

export const IconMoon: FC<IconMoonProps> = ({
  name,
  size = 'xl',
  ...props
}) => {
  const styledProps = getStyledElementProps(
    props,
    classNames(styles['root'], styles[`size-${size}`], `${name}`)
  )

  const createSpan = (): JSX.Element[] | null => {
    const countElementsToCreate: { [key: string]: number } = {
      'icon-1': 200,
      'icon-2': 186,
      'icon-3': 141,
      'icon-4': 151,
      'icon-5': 170,
      'icon-6': 196,
      'icon-7': 194,
      'icon-8': 181,
      'icon-9': 199,
      'icon-uy': 198,
      'icon-us': 197,
      'icon-pe': 195,
      'icon-x': 185,
    }
    if (complexIconMoonName.includes(name)) {
      const listToRender = Array(countElementsToCreate[name])
        .fill(1)
        .map((n, i) => n + i)
      const renderSpan = listToRender.map((value) => (
        <span key={value.toString()} className={`path${value}`} />
      ))
      return renderSpan
    }
    return null
  }

  return <span {...styledProps}>{createSpan()}</span>
}
